import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "v1-installments__pay-before",
  "data-testid": "v1-pay-before"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageLoading = _resolveComponent("PageLoading")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_CustomerioBanner = _resolveComponent("CustomerioBanner")!
  const _component_V1ScreenScaffold = _resolveComponent("V1ScreenScaffold")!
  const _component_NoPayments = _resolveComponent("NoPayments")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_PageLoading, { key: 0 }))
    : (_ctx.error)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, { key: 1 }))
      : (_ctx.paymentInfo && _ctx.paymentInfo.installments.length > 0)
        ? (_openBlock(), _createBlock(_component_V1ScreenScaffold, {
            key: 2,
            title: _ctx.paymentInfo.title,
            "next-disabled": !_ctx.canContinue,
            "data-testid": "v1-installments",
            onNext: _ctx.handleContinue
          }, {
            subtitle: _withCtx(() => [
              (_ctx.paymentInfo.validThrough && _ctx.paymentInfo.validThrough.display)
                ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.paymentInfo.validThrough.isOverdue ? 'v1-installments__pay-before--overdue' : '')
                    }, _toDisplayString(_ctx.paymentInfo.validThrough.label), 3),
                    _createTextVNode(" " + _toDisplayString(_ctx.paymentInfo.validThrough.display), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_RadioGroup, {
                "model-value": _ctx.selectedValue,
                options: _ctx.installmentOptions,
                "aria-label": _ctx.paymentInfo.title,
                "data-testid": "v1-installment-options",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedValue = String($event)))
              }, null, 8, ["model-value", "options", "aria-label"]),
              (_ctx.hasTail)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "v1-installments__toggle",
                    "data-testid": "v1-installments-toggle",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.expanded = !_ctx.expanded))
                  }, _toDisplayString(_ctx.expanded ? _ctx.paymentInfo.visibility.labelExpanded : _ctx.paymentInfo.visibility.labelCollapsed), 1))
                : _createCommentVNode("", true),
              (_ctx.customOptions.length > 0)
                ? (_openBlock(), _createBlock(_component_RadioGroup, {
                    key: 1,
                    "model-value": _ctx.selectedValue,
                    options: _ctx.customOptions,
                    "data-testid": "v1-other-amount",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedValue = String($event)))
                  }, null, 8, ["model-value", "options"]))
                : _createCommentVNode("", true),
              _createVNode(_component_CustomerioBanner)
            ]),
            _: 1
          }, 8, ["title", "next-disabled", "onNext"]))
        : (_openBlock(), _createBlock(_component_NoPayments, { key: 3 }))
}